module.exports = __webpack_public_path__ + "static/siding-8b1b09f29138c46d40480d8b7dfcffaa.jpg";